import { useSearchParams, Link } from "react-router-dom"
import { Card } from "@/components/ui/card"

export default function LoginErrorPage() {
  const [searchParams] = useSearchParams()
  const error = searchParams.get("error")

  const errorMessages: Record<string, string> = {
    AccessDenied: "You don't have permission to access this resource.",
    Verification: "The verification link has expired or has already been used.",
    Configuration: "There is a problem with the server configuration.",
    default: "An error occurred during sign-in. Please try again.",
  }

  const errorMessage = errorMessages[error || ''] || errorMessages.default

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <Card className="w-full max-w-md p-8">
        <div className="text-center">
          <div className="mx-auto flex items-center justify-center h-12 w-12 rounded-full bg-red-100 mb-4">
            <svg
              className="h-6 w-6 text-red-600"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>

          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Sign in error
          </h1>

          <p className="text-gray-600 mb-6">
            {errorMessage}
          </p>

          <div className="mt-8">
            <Link
              to="/login"
              className="text-sm text-blue-600 hover:text-blue-800 underline"
            >
              Back to sign in
            </Link>
          </div>
        </div>
      </Card>
    </div>
  )
}

